import * as t from "io-ts";

export const NoteAppTypeSchema = t.union([t.literal("portal"), t.literal("mobile"), t.literal("vr")]);
const NoteLocaleSchema = t.refinement(t.string, value => /^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(value) && value.length <= 16, "note locale");

export const GetHealthNotesRequestSchema = t.type({
  locale: NoteLocaleSchema,
  app_type: NoteAppTypeSchema,
});

export const HealthNoteSchema = t.type({
  id: t.number,
  key: t.string,
  version: t.string,
  title: t.string,
  locale: t.string,
  description: t.string,
  content: t.string,
  published_at: t.string,
  app_types: t.array(NoteAppTypeSchema),
});

export const GetHealthNotesResponseSchema = t.type({ notes: t.array(HealthNoteSchema) });
export type GetHealthNotesRequest = t.TypeOf<typeof GetHealthNotesRequestSchema>;
export type GetHealthNotesResponse = t.TypeOf<typeof GetHealthNotesResponseSchema>;
export type HealthNote = t.TypeOf<typeof HealthNoteSchema>;

export const NoteApis = {
  Notes: {
    GetHealthNotes: {
      Name: "notes-getHealthNotes",
      Request: GetHealthNotesRequestSchema,
      Response: GetHealthNotesResponseSchema,
    },
  },
};
